import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef} from '@angular/core';
import {DemoService} from '../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../services/mysql.service';



import { Job } from '../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';




import { FileUploaderService } from './../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';

@Component({
  selector: 'app-agent-view-subject',
  templateUrl: './agent-view-subject.component.html',
  styleUrls: ['./agent-view-subject.component.css']
})
export class AgentViewSubjectComponent implements OnInit {

  subjects: any;
  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  subject_notes: Object;
  subject_id: number;
  job_status: Object;
  subject_contact_numbers: any;
  subject_contact_emails: any;
  job_id: any;
  file_number: any;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public gfunc: GlobalFunctionsService,
  ) {

    this.nav = document.querySelector('nav.navbar');
    

  // login vars
  this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
  console.log('sessionUserId: ', this.currentUserVAR.user_id );
  console.log('sessionUsername: ', this.currentUserVAR.username );
  // Set loggind in User Value (USER ID)
  this.sessionUserId = this.currentUserVAR.user_id;
  this.sessionUserId = this.currentUserVAR.username;
  this.sessionBrandId = this.currentUserVAR.brand_id;
   }

  ngOnInit() {
    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
    this.getJobSubject(this.subject_id);
    this.getJobStatusNames();
    this.getSubjectContactNumbers(this.subject_id)
    this.getSubjectContactEmails(this.subject_id)
  }



  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subjects = data;
        let res = data[0];
        this.job_id = res.job_id;
        this.file_number = res.file_number;
        this.getSubjectNotes(res.subject_id);
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   
   private getJobStatusNames() {
    this._demoService.getJobStatusNames()
      .subscribe(
        res => this.job_status = res,
        err => console.error(err.status)
      );
  }


  getSubjectNotes(subject_id) {
    this._demoService.getSubjectNotes(subject_id).subscribe(
      data => { this.subject_notes = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      },
      error => {
      //  console.error('Error Loading User!');
      // return Observable.throw(error);
      }
    );}



    subjectEdit(subject_id) {
      this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
    }
    
    subjectView(subject_id) {
      this.router.navigate(['/admin/jobs/subject/view/' + subject_id + '']);
    }
    jobView(job_id) {
      this.router.navigate(['/admin/jobs/view/' + job_id + '']);
    }



    getSubjectContactNumbers(subject_id) {
      this._demoService.getSubjectContactNumbers(subject_id).subscribe(
         data => { this.subject_contact_numbers = data; },
         err => console.log(err),
          () => {
            // console.log('done loading SCN');
                        }
            );
     }



     getSubjectContactEmails(subject_id) {
      this._demoService.getSubjectContactEmails(subject_id).subscribe(
         data => { this.subject_contact_emails = data; },
         err => console.log(err),
          () => {
            // console.log('done loading SR');
                        }
            );
     }
    


}
